import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const FamilyListPage = () =>
    import ('@modules/family/components/family-list-page.vue');
const FamilyFormPage = () =>
    import ('@modules/family/components/family-form-page.vue');
const FamilyViewPage = () =>
    import ('@modules/family/components/family-view-page.vue');
const FamilyImporterPage = () =>
    import ('@modules/family/components/family-importer-page.vue');

export default [{
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [{
            props: true,
            name: 'family',
            path: '/family/:subpropertyid',
            component: FamilyListPage,
            meta: {
                auth: true,
                permission: Permissions.values.familyView,
            },
        },
        {
            props: true,
            name: 'familyNew',
            path: '/family/new/:subpropertyId',
            component: FamilyFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.familyCreate,
            },
        },
        {
            props: true,
            name: 'familyImporter',
            path: '/family/import/:subpropertyid',
            component: FamilyImporterPage,
            meta: {
                auth: true,
                permission: Permissions.values.familyImport,
            },
        },
        {
            name: 'familyEdit',
            path: '/family/:id/edit/:subpropertyid',
            component: FamilyFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.familyEdit,
            },
            props: true,
        },
        {
            name: 'familyView',
            path: '/family/:id/:subpropertyId',
            component: FamilyViewPage,
            meta: {
                auth: true,
                permission: Permissions.values.familyView,
            },
            props: true,
        },
    ],
}, ];